import { GROUP_ROLE } from '@pages/K2Report/constants.js';
import {
  SET_POLICY_DATA,
  SET_POLICY_DETAIL_DATA,
  SET_K2_REPORT_BREADCRUMB_DATA,
  SET_K2_REPORT_DATETIME_DATA,
  SET_K2_REPORT_SELECTED_BREADCRUMB_DATA,
  SET_K2_REPORT_SELECTED_TAB_DATA,
  SET_K2_REPORT_SUMMARY_DATA,
  SET_K2_REPORT_TABLE_DATA,
  SET_K2_REPORT_FILTER,
  SET_TEAM_POLICY_DATA,
  RESET_POLICY_DATA,
  RESET_STATE,
  FETCH_POLICY_LIST_START,
  FETCH_POLICY_LIST_SUCCESS,
} from './constants.js';

export const initialState = {
  datetimeData: [],
  salesData: {},
  salesSummaryData: {},
  breadcrumbData: {},
  configFilter: {
    type: 'monthly',
    datetime: '',
    issuedDateFrom: '',
    issuedDateTo: '',
    policyNumber: '',
    policyStatusCode: '',
    serviceAgentInfo: '',
    code: 'ACT12',
    page: 0,
    size: 10,
    sort: 'renw_prem_pct:ASC',
    policySort: 'issued_dt:DESC',
    exclusiveStartKey: null,
    isTopNode: false,
    isIndirectHierarchy: false,
  },
  selectedBreadcrumbId: 'ACT1',
  policyData: [],
  policyDetailData: null,
  selectedTabId: GROUP_ROLE,
  isLoadingPolicyList: false,
};

const k2ReportReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_K2_REPORT_DATETIME_DATA:
      state = {
        ...state,
        datetimeData: payload,
      };
      break;
    case SET_K2_REPORT_TABLE_DATA:
      state = {
        ...state,
        salesData: payload,
      };
      break;
    case SET_K2_REPORT_FILTER:
      state = {
        ...state,
        configFilter: payload,
      };
      break;
    case SET_K2_REPORT_SUMMARY_DATA:
      state = {
        ...state,
        salesSummaryData: payload,
      };
      break;
    case SET_K2_REPORT_BREADCRUMB_DATA:
      state = {
        ...state,
        breadcrumbData: payload,
      };
      break;
    case SET_K2_REPORT_SELECTED_BREADCRUMB_DATA:
      state = {
        ...state,
        selectedBreadcrumbId: payload,
      };
      break;
    case SET_K2_REPORT_SELECTED_TAB_DATA:
      state = {
        ...state,
        selectedTabId: payload,
      };
      break;
    case SET_POLICY_DATA:
      state = {
        ...state,
        policyData: payload,
      };
      break;
    case RESET_POLICY_DATA:
      return {
        ...state,
        policyData: [],
      };
    case SET_POLICY_DETAIL_DATA:
      state = {
        ...state,
        policyDetailData: payload,
      };
      break;
    case SET_TEAM_POLICY_DATA:
      state = {
        ...state,
        teamPolicyData: payload,
      };
      break;
    case RESET_STATE:
      state = {
        ...initialState,
      };
      break;
    case FETCH_POLICY_LIST_START:
      state = {
        ...state,
        isLoadingPolicyList: true,
      };
      break;
    case FETCH_POLICY_LIST_SUCCESS:
      state = {
        ...state,
        isLoadingPolicyList: false,
      };
      break;
    default:
      break;
  }
  return state;
};

export default k2ReportReducers;
